import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

import { get } from 'lodash';

import auth from './auth';
import errorUserNotification from './errorUserNotification';
import CartReducer from './CartReducer';
import EditorialHomework from './EditorialHomeworkReducer';
import EditorialHomeworkDetailReducer from './EditorialHomeworkDetailReducer';
import Exercise from './ExerciseReducer';
import FavouriteEditorialHomework from './FavouriteEditorialHomeworkReducer';
import FavouriteExercise from './FavouriteExercisesReducer';
import FavouriteHomework from './FavouriteHomeworkReducer';
import Homework from './HomeworkReducer';
import HomeworkDetailReducer from './HomeworkDetailReducer';
import HomeworkExportReducer from './HomeworkExportReducer';
import Invalsi from './InvalsiReducer';
import MenuReducer from './MenuReducer';
import SearchFormReducer from './SearchFormReducer';
import RelatedItemsReducer from './RelatedItemsReducer';
import Special from './SpecialReducer';
import SupportRequestReducer from './SupportRequestReducer';
import TickerReducer from './TickerReducer';
import userNotification from './userNotification';
import { RESUME_LOGIN_SUCCESS } from '../actions/auth';

const appReducer = combineReducers({
    auth,
    errorUserNotification,
    CartReducer,
    EditorialHomework,
    EditorialHomeworkDetailReducer,
    Exercise,
    FavouriteEditorialHomework,
    FavouriteExercise,
    FavouriteHomework,
    Homework,
    HomeworkDetailReducer,
    HomeworkExportReducer,
    Invalsi,
    MenuReducer,
    SearchFormReducer,
    RelatedItemsReducer,
    Special,
    SupportRequestReducer,
    TickerReducer,
    form,
    userNotification
});

const rootReducer = (state, action) => {
    if (action.type === RESUME_LOGIN_SUCCESS) {
        if (get(state, 'auth.persistentUserId') !== action.payload.userId) {
            state = undefined;
        }
    }
    return appReducer(state, action);
};

export default rootReducer;
